import React, { useState, useEffect } from 'react'
import { LeftTextRightPicture, Quote, goldColour, CatchPhrase, CallToActionButtons, reMindTopics, reMindArgomenti, Testimonials, GoldTags } from '../Home';
import T from '../../components/Translation';
import { useStateContext } from '../../context/StateContext';
import { useMutation } from '@tanstack/react-query';
import { _CREATEPUBLIC } from '../../utils/patches';
import { useAuthContext } from '../../whitaijiFrontendLibrary/auth/hooks/useAuthContext';
import { AuthContext } from '../../context/AuthContext';


const Webinar = () => {

const {hideTestButtons, language, apiUrl} = useStateContext(); 
const urlParams = new URLSearchParams(window.location.search);
const {user} = useAuthContext(AuthContext)
const campaignId = urlParams.get('campaignId');
const emailId = urlParams.get('emailId');
const email = urlParams.get('userEmail');
const pageId = "webinar";
const [emailLogged, setEmailLogged] = useState(false); 

const campaignLog = {
        logType:"emailLink", 
        campaignId, 
        emailId, 
        prospectEmail: email, 
        user_id: user?._id, 
        pageId
    }
        const { mutate: marketingLogsData } = useMutation({
        mutationFn: async(doc) => {
          try {
              return await _CREATEPUBLIC({
                doc, 
                route: `${apiUrl}/marketing-logs/public`, 
              });
            
          } catch (error) {
            throw error;
          }
        },
        mutationKey: ['marketingLogsData'],
        onSuccess: () => {
            setEmailLogged(true)
        }
      });
        useEffect(() => {
            if (!emailLogged && urlParams && emailId && emailId !== "undefined") {
                marketingLogsData(campaignLog)
            }
        }, [emailId])

  return (
<div>
    <div style={{padding: "30px", marginLeft:"20%", marginRight:"20%"}}>
        <CatchPhrase    
            motto = {<T obj={{en:"Learn how to keep your clients engaged in between sessions with", it:"Scopri come mantenere i tuoi clienti interessati tra le sessioni"}}/>}
            highlightedWords = {<T str={"reMind"}/>}
            catchPhrase = {<T obj={{en:"How to help your clients exercise the great work you do consistently", it:"Come aiutare i tuoi clienti a esercitare il grande lavoro con costanza"}}/>}
            highlightedCatchPhrase = {<T obj={{en:"With powerful songs and affirmations", it:"Con canzoni ed affermazioni"}}/>}
          />
    </div>
    <LeftTextRightPicture imageStyle={{width:"80%"}} imageContainerStyle={{alignItems:"flex-end"}} screenChange={1310} imageSource={"/homePictures/mikeProfile.png"}>
        <div style={{display:"flex", alignItems:"center", flexDirection:"column"}}>

          <CallToActionButtons
            style={{marginTop:"10px", marginBottom:"20px"}}  
            blueButtonText = {<T obj={{en:"Join The Webinar Now", it:"Unisciti Al Webinar Ora"}}/>}
            //blueButtonText = {<T str={"howYouFeel"}/>} 
            blueButtonFn={() => {
              window.scrollTo(0, 0);
              //navigate('/tell-me-how-you-feel');
            }}
          />
        </div>
      </LeftTextRightPicture>  
            <div className={"blue-background"}>
       <Quote style={{marginTop:"10px"}} dark author = {"Michael Bianco"}>
{/*           "Take a moment to remember one song that has had a strong emotional impact in your life. <br/>
          recreate the feeling that it sparked inside of you. <br/> 
          How do you feel?" */}
          <T obj = {{
            en: <>
                  Consistent repetition is key to behavioural growth and psychological transformation.
                  <br />
                  Music merged with powerful affirmations can help your clients exercise mental strength
                  <br />
                  and form new neural pathways faster.
                </>,
            it: <>
                  La ripetizione costante è la chiave per la crescita comportamentale e la trasformazione psicologica.
                  <br />
                  La musica, unita a potenti affermazioni, può aiutarti a rafforzare la mente
                  <br />
                  e a formare nuove connessioni neurali più rapidamente.
                </>
          }} />
        </Quote>
        <Testimonials slideHeight={300} slideWidth={450} />
        <div style={{display:"flex",  alignItems:"center", justifyContent:"center"}}>
            <h2><T obj={{en:"Topics", it:"Argomenti"}}/></h2>
        </div>
        <GoldTags tagList = {language == "it" ? reMindArgomenti : reMindTopics}/>
  
      </div>
    </div>
  )
}

export default Webinar
